// extracted by mini-css-extract-plugin
export var activeDot = "_5m-c";
export var buttonContainer = "_5m-9";
export var channelButton = "_5m-a";
export var clickable = "_5m-d";
export var content = "_5m-0";
export var contentFull = "_5m-2";
export var contentThird = "_5m-1";
export var contentWrapper = "_5m-7";
export var description = "_5m-5";
export var heightShort = "_5m-f";
export var image = "_5m-3";
export var imageContainer = "_5m-4";
export var selectButton = "_5m-e";
export var spinnerContainer = "_5m-b";
export var titleContent = "_5m-8";
export var titleWrapper = "_5m-6";